<template>
    <div class="p-3">
        <span v-if="reservePacks.length > 0">{{$t('backoffice.modules-management.vrm.new-access.reserve-pack.title')}}</span>

        <v-row class="d-flex flex-column mt-2 ml-1">
            <v-col v-for="(pack, index) in reservePacks" :key="index" style="margin-bottom: -10px">
                <span class="packs-name">{{`${pack.quantity} ${$t('backoffice.modules-management.vrm.new-access.reserve-pack.queries')}, ${pack.invoiceNumber}, ${pack.endDate}`}}</span>
                <span @click="$emit('delete-reserve-pack', pack, index)">
                    <img
                        src="/images/_SVGs/bo/remove.svg"
                        class="circle ml-3"
                        onload="SVGInject(this)"
                        width="12"
                        height="12"
                    />
                </span>
            </v-col>
        </v-row>

        <v-col class="mt-4" v-if="isCompanyBellowTips">
            <v-btn fab dark x-small color="var(--v-primary-base)" @click="onClickReservePack">
                <v-icon dark>
                    mdi-plus
                </v-icon>
            </v-btn>
            <span @click="onClickReservePack" class="ml-3 span-packs">{{$t('backoffice.modules-management.vrm.new-access.reserve-pack.create-new-reserve-pack')}}</span>
        </v-col>
    </div>
</template>

<script>
export default {

    props: {
        reservePacks: Array | Object
    },
    computed: {
        isCompanyBellowTips() {
            return this.$store.getters['auth/getState'].isCompanyBellowTips;
        }
    },
    methods: {
        onClickReservePack() {
            this.$emit('reserve-pack-btn');
        }
    }
};
</script>

<style lang="scss" scoped>
@import "@sass/_variables.scss";

.packs-name {
    text-align: left;
    font: normal normal normal 12px/30px Lato;
    letter-spacing: 0px;
    color: #9E9D9D;
    opacity: 1;
}

.span-packs {
    color: var(--v-primary-base);
    cursor: pointer;
}
</style>
